module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-personal-activities/master-personal-activities.component.scss
// module id = ./src/app/master/master-personal-activities/master-personal-activities.component.scss
// module chunks = main